import { timelineCategory } from "@constants/Clients/rocketFactory/enum";
import { TIMELINE_CATEGORIES } from "@constants/Clients/rocketFactory/timeline";

export const getTimelineCategory = (category: timelineCategory) => {
  return TIMELINE_CATEGORIES.find(({ value }) => value === category);
};
